import React, {useMemo, useState} from 'react';
import Select from 'react-select';
import {PERIOD} from '../../EditProcess/transactions';
import {customStyles, DropdownIndicator} from '../../../../../components';
import {getAggregateValue} from '../hooks/ruleUtils';

export const TimePeriod = ({rulePeriod, onChange}) => {
  console.log('rulePeriod', rulePeriod);
  const [period, setPeriod] = useState(null);
  const {currentPeriod, currentCount} = useMemo(
    () => getAggregateValue(rulePeriod),
    [rulePeriod],
  );
  const [count, setCount] = useState(currentCount || '');

  return (
    <div>
      <label
        htmlFor="end_process"
        className="mt-4 w-full mb-2 relative text-left"
      >
        <div>Over Time Period</div>
      </label>
      <div className="flex gap-3 w-full items-center">
        <input
          type="number"
          className="w-[70px] h-[45px] bg-white px-2 text-[14px] text-body text-center"
          value={count}
          onChange={e => {
            setCount(e.target.value);
            setPeriod({});
          }}
        />

        <Select
          value={period || currentPeriod}
          onChange={data => {
            setPeriod(data);
            onChange({
              count,
              period: data?.value,
            });
          }}
          options={PERIOD}
          placeholder="Days"
          className="basic-multi-select white-select flex-1"
          classNamePrefix="react-select"
          components={{DropdownIndicator}}
          styles={customStyles}
          menuPlacement="auto"
        />
      </div>
    </div>
  );
};
